import { render, staticRenderFns } from "./SupportCollectomateOpenLockerModal.vue?vue&type=template&id=5aa6de32&scoped=true&lang=pug&"
import script from "./SupportCollectomateOpenLockerModal.vue?vue&type=script&lang=js&"
export * from "./SupportCollectomateOpenLockerModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportCollectomateOpenLockerModal.vue?vue&type=style&index=0&id=5aa6de32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa6de32",
  null
  
)

export default component.exports